module.exports = __webpack_public_path__ + "static/media/bumpersticker.02ba5644.jpg";